export const printConfig = {
  defaults: {
    fontName: 'Arial',
    fontSize: 11,
    links: {
      fontName: 'Arial',
      fontSize: 11
    }
  },
  mainHeading: {
    fontSize: 14,
    showBottomBorder: false
  },
  subHeading: {
    fontSize: 12
  },
  topic: {
    fontName: 'Arial',
    fontSize: 12
  }
}
